module.exports = __webpack_public_path__ + "img/alimenticia.f7955358.png";